export default __webpack_public_path__ + "static/media/SFTP_image_6.ab669846.jpg";